'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

export default function LyticsScript() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.jstag) {
      window.jstag.pageView();
    }
  }, [pathname]); // Runs on each route change

  return (
    <Script id="lytics-script" strategy="afterInteractive">
      {`
        !function(){"use strict";var o=window.jstag||(window.jstag={}),r=[];
        function n(e){o[e]=function(){for(var n=arguments.length,t=new Array(n),i=0;i<n;i++)t[i]=arguments[i];r.push([e,t])}}
        n("send"),n("mock"),n("identify"),n("pageView"),n("unblock"),n("getid"),n("setid"),
        n("loadEntity"),n("getEntity"),n("on"),n("once"),n("call"),
        o.loadScript=function(n,t,i){
          var e=document.createElement("script");
          e.async=!0,e.src=n,e.onload=t,e.onerror=i;
          var o=document.getElementsByTagName("script")[0],
              r=o&&o.parentNode||document.head||document.body,
              c=o||r.lastChild;
          return null!=c?r.insertBefore(e,c):r.appendChild(e),this
        },
        o.init=function n(t){
          return this.config=t,
          this.loadScript(t.src,function(){
            if(o.init===n)throw new Error("Load error!");
            o.init(o.config),
            function(){
              for(var n=0;n<r.length;n++){
                var t=r[n][0],i=r[n][1];
                o[t].apply(o,i)
              }
            }()
            r=void 0
          }),
          this
        }}();
        jstag.init({
          stream: "leesa_sleep",
          src: 'https://c.lytics.io/api/tag/78fd98409f7bd2b894f60685c4fb1057/latest.min.js'
        });
      `}
    </Script>
  );
}
